export default __webpack_public_path__ + "13cadbbb2f281af8a8ee2d5628d068b6.png";